import {UnknownError} from "../constants/auth.ts";

export type ErrorWithName = {
    name: string
}

export const isErrorWithName = (error: unknown): error is ErrorWithName =>
    typeof error === 'object' && error !== null && 'name' in error && typeof error.name === 'string';

export const nameFromError = (error: unknown): string => {
    if (isErrorWithName(error)) {
        return error.name
    }
    return UnknownError
}
